import Swiper from 'swiper/dist/js/swiper'
import { setTimeout } from 'timers'
import imagesLoaded from 'imagesloaded'

export function initProductSlider() {
  const mySwiperThumbs = new Swiper('.js-product-swiper-thumbs', {
    spaceBetween: 15,
    slidesPerView: 4,
    // freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: 'vertical',
    // allowTouchMove: false,

    breakpoints: {
      // when window width is <= 320px

      1270: {
        slidesPerView: 2,
      },
      // when window width is <= 640px
      1400: {
        slidesPerView: 3,
      },
    },
  })

  const mySwiper = new Swiper('.js-product-swiper', {
    speed: 400,
    spaceBetween: 40,
    grabCursor: true,
    navigation: {
      nextEl: '.c-icon--next-slide',
      prevEl: '.c-icon--prev-slide',
    },
    thumbs: {
      swiper: mySwiperThumbs,
    },
  })

  const currentSlideDisplay = document.querySelector(
    '.c-slide-controls__counter > .current',
  )
  mySwiper.on('slideChange', () => {
    currentSlideDisplay.textContent = mySwiper.activeIndex + 1
  })
}

export function initRelProductSlider() {
  const mySwiper = new Swiper('.c-product-related__swiper', {
    speed: 400,
    spaceBetween: 100,
    slidesPerView: 3,
    roundLengths: true,
    navigation: {
      nextEl: '.c-icon--next-prod',
      prevEl: '.c-icon--prev-prod',
    },
    on: {
      init() {
        const swiperSlidecount = this.slides.length
        const swiperWrapper = document.querySelector(
          '.c-product-related-slider-outer',
        )

        if (swiperSlidecount < 3) {
          swiperWrapper.classList.add(
            'c-product-related-slider-outer--no-controls',
          )
        }
      },
    },
    breakpoints: {
      600: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1300: {
        spaceBetween: 50,
      },
    },
  })
}

export function initRelProductSliderSm() {
  const mySwiper = new Swiper('.c-product-related__swiper-sm', {
    speed: 400,
    spaceBetween: 60,
    slidesPerView: 2,
    roundLengths: true,
    navigation: {
      nextEl: '.c-icon--next-prod',
      prevEl: '.c-icon--prev-prod',
    },
    on: {
      init() {
        const swiperSlidecount = this.slides.length
        const swiperWrapper = document.querySelector(
          '.c-product-related-slider-outer',
        )

        if (swiperSlidecount < 2) {
          swiperWrapper.classList.add(
            'c-product-related-slider-outer--no-controls',
          )
        }
      },
    },
    breakpoints: {
      // 600: {
      //   slidesPerView: 1,
      //   spaceBetween: 20,
      // },
      // 900: {
      //   slidesPerView: 1,
      //   spaceBetween: 30,
      // },
      1150: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      1500: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  })
}

export function initRelReferencesSlider() {
  const mySwiper = new Swiper('.c-product-references__swiper', {
    speed: 400,
    spaceBetween: 100,
    slidesPerView: 3,
    roundLengths: true,
    navigation: {
      nextEl: '.c-icon--next-prodref',
      prevEl: '.c-icon--prev-prodref',
    },
    on: {
      init() {
        const swiperSlidecount = this.slides.length
        const swiperWrapper = document.querySelector(
          '.c-product-references-slider-outer',
        )

        if (swiperSlidecount < 3) {
          swiperWrapper.classList.add(
            'c-product-references-slider-outer--no-controls',
          )
        }
      },
    },
    breakpoints: {
      600: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1300: {
        spaceBetween: 50,
      },
    },
  })
}

export function initAboutArticlesSlider() {
  const currentSlideDisplay = document.querySelector(
    '.c-slide-controls__counter > .current',
  )
  const mySwiper = new Swiper('.c-about-articles__container', {
    speed: 400,
    spaceBetween: 26,
    slidesPerView: '2',
    navigation: {
      nextEl: '.c-icon--next-slide',
      prevEl: '.c-icon--prev-slide',
    },
    breakpoints: {
      800: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
    on: {
      // slideChange() {
      //   currentSlideDisplay.textContent = this.realIndex + 1
      // },
    },
  })

  mySwiper.on('slideChange', () => {
    currentSlideDisplay.textContent = mySwiper.activeIndex + 1
  })
}

export function initHomeReferencesSlider() {
  const mySwiper = new Swiper('.c-home-references__container', {
    speed: 400,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.c-icon--next',
      prevEl: '.c-icon--prev',
    },
    breakpoints: {
      400: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  })
}

export function initLatestArticlesSlider() {
  const mySwiper = new Swiper('.c-article-swiper-container', {
    speed: 400,
    spaceBetween: 26,
    slidesPerView: '2',
    navigation: {
      nextEl: '.c-icon--next-article',
      prevEl: '.c-icon--prev-article',
    },
    breakpoints: {
      400: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  })
}

export function initSingleReferenceSlider() {
  const pageWidth = window.innerWidth
  const button_prev =
    pageWidth > 1000
      ? document.querySelector('.c-icon__gallery-prev')
      : document.querySelector('.c-icon--prev-slide')
  const button_next =
    pageWidth > 1000
      ? document.querySelector('.c-icon__gallery-next')
      : document.querySelector('.c-icon--next-slide')

  const currentSlideDisplay = document.querySelector(
    '.c-slide-controls__counter > .current',
  )

  const mySwiper = new Swiper('.c-gallery__wrap > .swiper-container', {
    init: false,
    speed: 400,
    slideToClickedSlide: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: button_next,
      prevEl: button_prev,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    on: {
      init() {
        this.slides[1].classList.remove('u-opacity-2')
      },
      slideChange() {
        this.slides[this.activeIndex].classList.remove('u-opacity-2')
        this.slides[this.previousIndex].classList.add('u-opacity-2')
        currentSlideDisplay.textContent = this.realIndex + 1
      },
    },
  })

  imagesLoaded(document.querySelector('.c-gallery__wrap'), () => {
    mySwiper.init()
  })
}
